/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateJudgmentNumberingDto
 */
export interface CreateUpdateJudgmentNumberingDto {
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateJudgmentNumberingDto
     */
    year?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateJudgmentNumberingDto
     */
    actualNumber?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateJudgmentNumberingDto
     */
    month?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateJudgmentNumberingDto
     */
    registerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateJudgmentNumberingDto
     */
    registerNumberingId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateJudgmentNumberingDto
     */
    userUID?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateJudgmentNumberingDto
     */
    symbol?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateJudgmentNumberingDto
     */
    type?: CreateUpdateJudgmentNumberingDtoTypeEnum | null;
}


/**
 * @export
 */
export const CreateUpdateJudgmentNumberingDtoTypeEnum = {
    Judgment: 'Judgment',
    Card: 'Card',
    SalesInvoice: 'SalesInvoice',
    SalesInvoiceCorrected: 'SalesInvoiceCorrected'
} as const;
export type CreateUpdateJudgmentNumberingDtoTypeEnum = typeof CreateUpdateJudgmentNumberingDtoTypeEnum[keyof typeof CreateUpdateJudgmentNumberingDtoTypeEnum];


/**
 * Check if a given object implements the CreateUpdateJudgmentNumberingDto interface.
 */
export function instanceOfCreateUpdateJudgmentNumberingDto(value: object): value is CreateUpdateJudgmentNumberingDto {
    return true;
}

export function CreateUpdateJudgmentNumberingDtoFromJSON(json: any): CreateUpdateJudgmentNumberingDto {
    return CreateUpdateJudgmentNumberingDtoFromJSONTyped(json, false);
}

export function CreateUpdateJudgmentNumberingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateJudgmentNumberingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'year': json['year'] == null ? undefined : json['year'],
        'actualNumber': json['actualNumber'] == null ? undefined : json['actualNumber'],
        'month': json['month'] == null ? undefined : json['month'],
        'registerId': json['registerId'] == null ? undefined : json['registerId'],
        'registerNumberingId': json['registerNumberingId'] == null ? undefined : json['registerNumberingId'],
        'userUID': json['userUID'] == null ? undefined : json['userUID'],
        'symbol': json['symbol'] == null ? undefined : json['symbol'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function CreateUpdateJudgmentNumberingDtoToJSON(value?: CreateUpdateJudgmentNumberingDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'year': value['year'],
        'actualNumber': value['actualNumber'],
        'month': value['month'],
        'registerId': value['registerId'],
        'registerNumberingId': value['registerNumberingId'],
        'userUID': value['userUID'],
        'symbol': value['symbol'],
        'type': value['type'],
    };
}

